import { Drawer } from 'antd';
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { leaveStatusOptions } from 'utils/constants';
const FilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty

}) => {
  const [placement] = useState('right');  
   const {

    userData, userDataLoading,

} = useSelector((state) => state.common);


const [userDataOption, setUserDataOption] = useState([]);



useEffect(()=>{
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    setUserDataOption(_userData)  

},[userData])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
          if(key === "nationality"){
            return selectedValue.value
          }
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Filters"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        footer={
          <div>
            {filters.some(filter => filter.value && filter.key !== "search") && (
              <Button
                label="Clear All"
                onClick={handleClearAll}
                className="btn btn-link w-100 mb-2 p-0"
                style={{ color: "var(--brand-text-muted)", fontWeight: 600 }}
              />
            )}
            <Button label="Apply Filter" loading={filterLoading} disabled={filterLoading || !isFilterDirty} onClick={handleApplyFilter} className="btn btn-primary w-100" style={{ borderRadius: "8px" }} />
          </div>
        }
      >
        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("reference_date")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "reference_date")}} 
        id="search" 
        label={"Reference date"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("posting_date")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "posting_date")}} 
        id="search" 
        label={"Posting date"} 
        />
        </div>



        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "approval_status")}} optionLabel={"label"} optionValue={'value'} options={leaveStatusOptions} value={setFilterValue("approval_status")} placeholder={"Approval status"}/>
        </div>



     

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "current_approver")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("current_approver")} placeholder={"Current Approver"}/>
        </div>


      </Drawer>
    </>
  );
};
export default FilterDrawer;